import {
  EDIT_MRD_SETTINGS_FAILURE,
  EDIT_MRD_SETTINGS_REQUEST,
  EDIT_MRD_SETTINGS_SUCCESS,
} from './types/DeviceSettingsActionTypes';

export function editMrdSettingsRequestActionCreator(action) {
  return {
    type: EDIT_MRD_SETTINGS_REQUEST,
    payload: action,
  };
}

export function editMrdSettingsSuccessActionCreator() {
  return {
    type: EDIT_MRD_SETTINGS_SUCCESS,
  };
}

export function editMrdSettingsFailureActionCreator(error) {
  return {
    type: EDIT_MRD_SETTINGS_FAILURE,
    payload: error,
    error: true,
  };
}
